export const patternNumber = /^(0|[1-9][0-9]*)$/;
export const patternPhoneNumber = /(\+84|0)+([3|5|7|8|9])+([0-9]{8})\b/;
export const patternNumberOnly = /^([\d]+)$/;
export const patternSocialNumber = /(^\w{3}[0-9]{6}$)|(^\w{1,2}[0-9]{7}$)|(^\d{9}$)|(^\d{12}$)|([A-Z]{1}[0-9]{7})/;
